module.exports = __webpack_public_path__ + "img/partner-gwo.c1dc2c98.webp";